import TablePage, { rows, columns } from './TablePage';

export { rows, columns };
export default TablePage;
